import { createReducer } from 'store/createReducer';
import { FAVOURITES_ADD, FavouritesAction, FAVOURITES_REMOVE } from './actions';
import { FavouritesModel } from 'models/FavouritesModel';

const reducer = {
  [FAVOURITES_ADD]: (state: FavouritesModel, { id }: FavouritesAction) => {
    return { ...state, productIds: [...new Set([...state.productIds, id])] };
  },
  [FAVOURITES_REMOVE]: (state: FavouritesModel, { id }: FavouritesAction) => {
    return { ...state, productIds: state.productIds.filter(pid => pid !== id) };
  }
};

export const initialState: FavouritesModel = {
  productIds: []
};
export default createReducer(initialState, reducer);
